import React from 'react';

const Mensaje = () => ( 
    <p>Agrega una cantidad y plazo a pagar para Cotizar</p>
 );

 
export default Mensaje;